import { render, staticRenderFns } from "./KnProductOptions.vue?vue&type=template&id=b35d0d40"
import script from "./KnProductOptions.js?vue&type=script&lang=js&external"
export * from "./KnProductOptions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports